 <!--Header Section Starts  -->
<header class="desktop-header">

  <div class="top-bar ">
    <div class="container top-bar">
      <div class="welcome-message">Welcome to <strong>{{companyShortName}}...</strong></div>
      <div class="social hidden-xs footer-social">
        <a href="{{facebook}}" target="_blank" class="external facebook" data-animate-hover="pulse">
          <i class="fab fa-facebook"></i>
        </a>
        <a href="{{instagram}}" target="_blank" class="external instagram" data-animate-hover="pulse">
          <i class="fab fa-instagram"></i>
        </a>
        <a href="{{twitter}}" target="_blank" class="external twitter" data-animate-hover="pulse"><i class="fab fa-twitter"></i></a>
        <a href="{{linkedin}}" target="_blank" class="external linkedin" data-animate-hover="pulse">
          <i class="fab fa-linkedin"></i>
        </a>
      </div>
      <div class="contact-info">
        <a href="mailto:{{ContactEmail}}" target="_blank"><i class="far fa-envelope"></i> {{ContactEmail}}</a>
        <a href="https://api.whatsapp.com/send?phone={{ContactNo}}&amp;text=Hello {{companyShortName}}, I Came Across Website. Please Let Me Know Your Booking Requirement. Thanks You!&amp;source=&amp;data=#" target="_blank" title="Whatsapp For  Booking Requirement - {{ContactNo}}">
          <img src="./assets/images/icons8-whatsapp-21.png"
                 alt=""> {{ContactNo}}
          </a>
          <!-- <span><i class="fas fa-globe"></i> ₹ INR</span>
    <span><i class="fas fa-user"></i> My Account <i class="fas fa-caret-down"></i></span> -->

          <div class="currency-dropdown">
            <button class="new-dropdown-toggle mob-currency" (click)="CurrencyShowPopup()">
              <div style="display:inline;" *ngIf="expectedCurrency ==''">Currency</div>
              <div style="display:inline;" *ngIf="expectedCurrency !=''">
                <img src="assets/images/SMT/MappedCountryCode/{{expectedCurrencyCode}}.png" alt="India Flag" class="flag-icon" />
                &nbsp;{{expectedCurrencySymbol}} {{expectedCurrency}}
              </div><i class="fa fa-angle-down"></i>
            </button>
            <div class="new-dropdown-menu" [ngStyle]="{'display':hideCurrencyPopup === true ? 'block' : 'none' }">
              <div class="currency-option" href="javascript:void(0)" *ngFor="let curr of CurrencyModelArray"
                   (click)="CurrencyChange(curr.CurrencyCode+'-'+curr.currencySymbol+'-'+curr.MappedCountryCode+'-'+curr.MappedCountryName)">
                <img src="assets/images/SMT/MappedCountryCode/{{curr.MappedCountryCode}}.png" alt="India Flag" class="flag-icon" />
                <span>{{curr.currencySymbol}}</span> {{curr.CurrencyCode}}
              </div>
              <!-- Add more options with flags here -->
            </div>
          </div>

          <div class="account-dropdown">
            <button class="account-dropdown-toggle mob-login" (click)="AccountShowPopup()">
              <img src="./assets/images/Icon/profile.png" alt="India Flag" class="flag-icon" />
              &nbsp;My Account <i class="fa fa-angle-down"></i>
            </button>
            <div class="account-dropdown-menu" [ngStyle]="{'display':accountPopup === true ? 'block' : 'none' }">
              <div class="account-option" (click)="SignInRegisterclick('Sign In')" *ngIf="!isLogin">
                <i class="fa fa-user" aria-hidden="true"></i>
                Sign In
              </div>
              <div class="account-option" (click)="SignInRegisterclick('Register')" *ngIf="!isLogin">
                <i class="fa fa-user" aria-hidden="true"></i>
                Register
              </div>
              <div class="account-option" *ngIf="isLogin">
                <i class="fa fa-user" aria-hidden="true"></i>
                <a class="colour-black" routerLink="/account/MyBookings">My Bookings</a>
              </div>
              <div class="account-option" *ngIf="isLogin">
                <i class="fa fa-user" aria-hidden="true"></i>
                <a class="colour-black" routerLink="/account/profile">My Profile</a>
              </div>
              <div class="account-option" (click)="Logout()" *ngIf="isLogin">
                <i class="fa fa-sign-out" aria-hidden="true"></i>
                Logout
              </div>
              <!-- Add more options with flags here -->
            </div>
          </div>
      </div>
    </div>

  </div>

  <div class="main-nav sticky-header ">
    <div class="container d-flex ">
      <div class="logo">
        <a href="./index.html"><img src="./assets/images/{{companyCode}}/Logo/{{logoName}}.png" alt="{{companyFullName}}"></a>
      </div>
      <nav>
        <ul class="main-menu">

          <li class="active1">
            <a href="javascript:void(0)" (click)="ChangeProduct('flight')" [ngClass]="{'active':product==='flight'}">
              <img src="./assets/images/Icon/flight-icon.png" alt="Flights">
              Flights
            </a>
          </li>
          <li class="hotels">
            <a href="javascript:void(0)" (click)="ChangeProduct('hotel')" [ngClass]="{'active':product==='hotel'}">
              <img src="./assets/images/Icon/hotel-icon.png" alt="Hotels">
              Hotels
            </a>
          </li>
          <li class="holidays">
            <a href="javascript:void(0)" (click)="ChangeProduct('holiday')" [ngClass]="{'active':product==='holiday'}">
              <img src="./assets/images/Icon/holiday-icon.png" alt="Holidays">
              Package
            </a>
          </li>
          <li class="transfer">
            <a href="javascript:void(0)" (click)="ChangeProduct('transfer')" [ngClass]="{'active':product==='transfer'}">
              <img src="./assets/images/Icon/transfer-icon.png" alt="Transfer">
              Transfer
            </a>
          </li>
          <li class="sightseeing">
            <a href="javascript:void(0)" (click)="ChangeProduct('sightseeing')" [ngClass]="{'active':product==='sightseeing'}">
              <img src="./assets/images/Icon/sightseeing-icon.png" alt="Sightseeing">
              Car
            </a>
          </li>
          <!--<li class="sightseeing coming-soon">
            <a href="#"  [ngClass]="{'active':product==='cruise'}">
              <img src="./assets/images/Icon/cruise-icon.png" alt="Cruise">
              Cruise
            </a>
          </li>
          <li class="sightseeing coming-soon">
            <a href="javascript:void(0)"  (click)="ChangeProduct('car')" [ngClass]="{'active':product==='car'}">
              <img src="./assets/images/Icon/car-icon.png" alt="Car">
              Car
            </a>
          </li>-->
        </ul>
      </nav>
      <div class="contact">
        <span>"Service available 24/7, anytime."</span> <br>
        <span class="phone"><i class="fa-solid fa-phone"></i> {{ContactNo}}</span>
      </div>
    </div>


  </div>
</header>
<!-- Header Section End -->
<!-- Mobile header strats -->
<header class="mobile-header">
  <div id="top mobile-top">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-md-9 col-sm-9">
          <div class="phone-home navbar-right ph-icon-show hidden-lg hidden-md hidden-sm darkHeader swiper">
            <div class="logo-container-new">
              <img src="./assets/images/{{companyCode}}/Logo/{{logoName}}.png" alt="{{companyFullName}}" class="logo">
            </div>
            <ul class="mobile-menu swiper-wrapper">
              <li class="menu-item swiper-slide" [ngClass]="{'active mob-menu-active':product==='flight'}">
                <a href="javascript:void(0)" (click)="ChangeProduct('flight')">
                  <img src="./assets/images/Icon/flight-icon.png" alt="Flights">
                  Flights
                </a>
              </li>
              <li class="menu-item swiper-slide" [ngClass]="{'active mob-menu-active':product==='hotel'}">
                <a href="javascript:void(0)" (click)="ChangeProduct('hotel')">
                  <img src="./assets/images/Icon/hotel-icon.png" alt="Hotels">
                  Hotels
                </a>
              </li>
              <li class="menu-item swiper-slide" [ngClass]="{'active mob-menu-active':product==='holiday'}">
                <a href="javascript:void(0)" (click)="ChangeProduct('holiday')">
                  <img src="./assets/images/Icon/holiday-icon.png" alt="Holidays">
                  Holidays
                </a>
              </li>
              <li class="menu-item swiper-slide" [ngClass]="{'active mob-menu-active':product==='transfer'}">
                <a href="javascript:void(0)" (click)="ChangeProduct('transfer')">
                  <img src="./assets/images/Icon/transfer-icon.png" alt="Visa"> Transfer
                </a>
              </li>
              <li class="menu-item swiper-slide" [ngClass]="{'active mob-menu-active':product==='Sightseeing'}">
                <a href="javascript:void(0)" (click)="ChangeProduct('sightseeing')">
                  <img src="./assets/images/Icon/sightseeing-icon.png" alt="sightseeing"> Sightseeing
                </a>
              </li>
              <li class="menu-item swiper-slide">
                <a href="javascript:void(0)" (click)="ChangeProduct('cruise')" [ngClass]="{'active':product==='cruise'}">
                  <img src="./assets/images/Icon/cruise-icon.png" alt="Cabs"> Cruise
                </a>
              </li>
              <li class="menu-item swiper-slide">
                <a href="javascript:void(0)" (click)="ChangeProduct('car')" [ngClass]="{'active':product==='car'}">
                  <img src="./assets/images/Icon/car-icon.png" alt="Cabs"> Car
                </a>
              </li>
            </ul>
            <div class="swiper-button-next"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
<!-- End Of Mobile Header -->
<div style="width:80% !important;">
  <ng-template #SignInRegisterPopup>

    <div class="modal-header">
      <h4 class="modal-title pull-left">{{SignInRegister}}</h4>
      <button type="button" class="close pull-right" style="background: none;" aria-label="Close"
              (click)="modalRef.hide(); SignInRegister='';">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <app-account *ngIf="SignInRegister=='Sign In'"></app-account>
      <app-register *ngIf="SignInRegister=='Register'"></app-register>
      <app-forget-password *ngIf="SignInRegister=='Forget Password'"></app-forget-password>
    </div>

  </ng-template>
</div>
